import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { GN } from '../../../../gn';
import { DIC } from '../../../dic';
import * as moment from 'moment';
import * as diff from 'diff';

/**
 * Generated class for the HistorylognalogPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-historylognalog',
  templateUrl: 'historylognalog.html',
})
export class HistorylognalogPage {
  loadingData: boolean = false
  nalogid: any
  nalogchanges = []
  hidepoi = []
  Title = ''

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC) {
    this.nalogid = this.navParams.get('did')
    this.Title = 'Историја на налог: ' + this.nalogid
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad HistorylognalogPage');
    this.loadData()
  }


  loadData() {
    this.loadingData = true
    var _that = this
    this.gn._Post('/api/gn/getChangeNalog', { hederid: this.gn.crypt(this.nalogid) }, function (_data) {
      console.log(_data, 'daj da vidam data')
      // console.log(_data, 'daj da vidam data')

      for (let i = 0; i < _data.length; i++) {
        _data[i].changes13 = ''
        if (_data[i].changes1.indexOf('&') != -1) {
          var arr = _data[i].changes1.split('&')
          _data[i].changes13 = 'Потврдил: ' + arr[1] + ' '
        }

        _that.hidepoi[i] = true;
        _data[i].createdt = moment(_data[i].createdt).format(_that.gn.user.DFormat) + ' ' + moment(_data[i].createdt).format(_that.gn.user.TFormat)
        if (_data[i].changes1 + '' != '') {
          _data[i].changes5 = _data[i].changes1.split('#')
          _data[i].changes7 = _data[i].changes1.split('#')
          _data[i].changes5 = _data[i].changes5.slice(0, _data[i].changes5.length - 1)
          _data[i].changes7 = _data[i].changes5.slice(0, _data[i].changes7.length - 1)
          for (let j = 0; j < _data[i].changes5.length; j++) {
            _data[i].changes5[j] = _that.dic.l["routelog" + _data[i].changes5[j].split(': ')[0]];// + 'од' + ' ' + _data[i].changes5[j].split(': ')[1].split('->')[0] + ' ' + 'во' + ' ' + _data[i].changes5[j].split(': ')[1].split('->')[1]
            _data[i].changes7[j] = /*_that.dic.l["routelog" + _data[i].changes5[j].split(': ')[0]] + */'од' + ' ' + _data[i].changes7[j].split(': ')[1].split('->')[0] + ' ' + 'во' + ' ' + _data[i].changes7[j].split(': ')[1].split('->')[1]
          }
        }
        //  var tmp = '2676710,2676711,2676712@Skopje,Гевгелија,Skopje->2676710,2676712,2676711@Skopje,Skopje,Гевгелија';
        // var tmp1 = ((tmp.split("->")[0]).split('@')[1]).split(',')
        // var tmp2 = ((tmp.split("->")[1]).split('@')[1]).split(',')
        if (_data[i].changes2 + '' != '') {
          _data[i].changes2 = _data[i].changes2.slice(0, _data[i].changes2.length - 1)
          _data[i].changes3 = ((_data[i].changes2.split("->")[0]).split('@')[1]).split(',')
          _data[i].changes4 = ((_data[i].changes2.split("->")[1]).split('@')[1]).split(',')

          var one = _data[i].changes3;//(_data[i].changes3).join('; ');//'Delicija1; Ilinden; Mida; Ruzvelt; Ilinden;',
          var other = _data[i].changes4;//(_data[i].changes4).join('; ');//'Delicija1; Ilinden; Ruzvelt; Orce;',
          var colorstr = '';
          var span = null;

          var diff1 = diff.diffArrays(one, other);
          var arrch = []
          diff1.forEach(function (part) {
            //debugger
            // green for additions, red for deletions
            // grey for common parts
            colorstr = part.added ? '#32db64' :
              part.removed ? '#f53d3d' : '#000000';
            var partArr = []
            partArr = part.value
            span = { color: colorstr, txt: partArr };
            arrch.push(span)
          });
          //debugger
          _data[i].changes6 = arrch;
        }
        // _data[i].changes2 = 


        // console.log(_data[i].changes2, 'daj da vidam')
        // for (let j = 0; j < _data[i].changes1.length; j++) {
        //   _data[i].changes1[j] = _data[i].changes1[j].split(' ')

        // }
        // _data[i].changes1 = _data[i].changes1.split(' ')
        // _data[i].changes2 = _data[i].changes2.split('->')
        // for (let c = 0; c < _data[i].changes1; c++) {
        //   _data[i].changes1[c]
        //   console.log(_data[i].changes1[c], 'daj da vidam')
        // }
        _data[i].userid = _that.gn.user.UserFullName

      }
      console.log(_that.nalogchanges, '_that.nalogchanges ')
      _that.nalogchanges = _data
      _that.loadingData = false
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/routing/routebank/reportorderbank/historylognalog.ts